module.exports = __webpack_public_path__ + "img/Skirt-Back-B4-Da-Fc-Gc-Hc-Ia-Gb.97182294.png";